if (typeof BSS_B2B != undefined) {
    window.addEventListener("cart_changed", () => {
        setTimeout(() => {
            let storeData = JSON.parse($("#bss-b2b-store-data").html());
            BSS_B2B.makeChangesAfterClickAjaxCart(500)
            BSS_B2B.cart.fixer(storeData, null, false);
            BSS_B2B.handleCartCheckoutBtn(storeData);
        }, 500);
    });
  
    setTimeout(() => {
        const targetMiniCart = document.querySelector("cart-drawer");
        if (targetMiniCart) {
            const mutationObserver = new MutationObserver((recordList, observe) => {
                BSS_B2B.makeChangesAfterClickAjaxCart(500)
                BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML), false, false);
                setTimeout(() => {
                    BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
                }, 1000)
            });
            mutationObserver.observe(targetMiniCart, {attributes: true});
        }
    }, 500)
  
    // fix spam checkout
    setTimeout(() => {
      function handleButtonClick(e) {
        e.preventDefault();
        const button = e.currentTarget;
    
        button.style.pointerEvents = 'none';
  
    
        setTimeout(() => {
          button.style.pointerEvents = 'unset';
          button.style.opacity = '1';
        }, 3000);
      }
    
      const observer = new MutationObserver(() => {
        const buttons = document.querySelectorAll('.bss-checkout');
        buttons.forEach(button => {
          // Tránh gán nhiều lần
          if (!button.hasAttribute('bss-click-bound')) {
            button.addEventListener('click', handleButtonClick);
            button.addEventListener('dblclick', handleButtonClick);
            button.setAttribute('bss-click-bound', 'true');
          }
        });
      });
    
      observer.observe(document.body, { childList: true, subtree: true });
    
      const buttons = document.querySelectorAll('.bss-checkout');
      buttons.forEach(button => {
        if (!button.hasAttribute('bss-click-bound')) {
          button.addEventListener('click', handleButtonClick);
          button.addEventListener('dblclick', handleButtonClick);
          button.setAttribute('bss-click-bound', 'true');
        }
      });
    }, 2000);
    BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
        window.location.href = "/checkout";
    }
}

// const checkoutUrls = ["cart/change", "cart/add"];
// const checkoutFetchOverride = () => {
//     if (!window.fetch || typeof window.fetch !== 'function') return;
//     const originalFetch = window.fetch;

//     window.fetch = function () {
//         const response = originalFetch.apply(this, arguments);
//         if (checkoutUrls.some(url => arguments[0].includes(url))) {
//           console.log("cart_changed")
//           BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html()), false, false);
//           BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html());
//         }
//         return response;
//     };
// };
// checkoutFetchOverride();
